document.addEventListener("DOMContentLoaded", function () {
  $(".footer-block__details-content .list-menu__item").click(function () {
    if ($(window).width() < 1000) {
      // 展开或者收起导航
      $(this).siblings(".sub-nav").slideToggle();
      // 判断是否展开，设置 + - 号
      if($(this).attr('active')) {
        $(this).removeAttr('active');
      } else {
        $(this).attr('active', 'true');
      }
    }
  });
});